@switch (specificTemplateName) {
  @case (tenantTableNames.Contacts) {
    <app-contacts-template
      [columnName]="columnName"
      [element]="element"
      [hideButtons]="hideButtons"
      [buttonFunctions]="buttonFunctions"
    ></app-contacts-template>
  }
  @default {
    @switch (columnName) {
      @case ('status') {
        <app-ui-pill [name]="element[columnName] + '' | lowercase"></app-ui-pill>
      }
      @case ('moduleList') {
        @for (module of element[columnName]; track module) {
          <div>{{ module | translate }}</div>
        }
      }
      @case ('department') {
        {{ element.department?.name }}
      }
      @case ('jobPosition') {
        {{ element.position?.name }}
      }
      @case ('shift') {
        {{ element.shift?.name }}
      }
      @case ('actionButton') {
        <app-ui-button
          color="primary"
          buttonType="icon-button"
          icon="delete"
          appConfirmDialog
          [confirmEntityName]="('mapping' | translate) + ' ' + element.name"
          (confirmed)="deleteMapping(element)"
        ></app-ui-button>
      }
      @default {
        <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
      }
    }
  }
}
